import { styled } from '@mui/system';
import { Link } from 'react-router-dom';

export const LogoLink = styled(Link)({
  textDecoration: 'unset',
});